import React from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { firstLetterUpperCase } from "../../shared/first-letter-upper";
import { ArrowRight, ArrowLeft } from '@mui/icons-material';
import ErikSussman from '../../assets/Erik Sussman.jpg'
import { removeSpaces } from "../../shared/shared";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const PresentationWelcomePage1 = (props) => {
  const client = useSelector((state) => state.dataStore.get("currentClient"));

  const ElementLi = ({ text, idx }) => {
    const rowStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0' }
    const textStyle = { marginLeft: '0.6em', fontSize: 'calc(0.40vw + 0.40vh + 0.30vmin)' }

    return (
      <li style={rowStyle}>
        <span className={"circled-number"}>{idx}</span>
        <Typography style={textStyle}>{text}</Typography>
      </li>)
  }

  const textList = [
    "Potentially lower or eliminate your taxes in retirement.",
    "Mitigate the effects of market volatility on your portfolio.",
    "Strategies to improve your chances of not running out of money in retirement."
  ]

  const ownerSignElement = { margin: '0', padding: '0' }

  const ClientAndOrSpouseNames = (props) => {
    const { client, spouse } = props.client;

    return (
      <Typography component={"h2"} fontWeight={"350"} fontSize={'calc(1vw + 0.4vh + 0.6vmin)'} mb={4} color={"#aaa"}>
        Dear {`${removeSpaces(firstLetterUpperCase(client.firstName))}${spouse != null ? ` and ${firstLetterUpperCase(spouse.firstName)},` : ','} `}
      </Typography>
    )
  }


  return (
    <Grid container >
      <Grid item xs={12} className={"top-gradient-bar"}></Grid>
      <Grid container display={'flex'} justifyContent={'center'} >

        <Grid item xs={12} md={10} sm={10} xl={7}>

          <Grid item xs={12} mr={5} pl={5} >
            <ClientAndOrSpouseNames client={client?.toJS()} />

            <Typography component={"p"} className={"typography-welcome-page"} >
              Congratulations, on continuing your journey towards greater financial
              clarity and confidence so you can live your best life in retirement.
              Your IFW Retirement Roadmap experience, guided by the knowledge and
              experience of your IFW Financial Professional will help you achieve
              three critical things:
            </Typography>

            <Typography component={"ul"} ml={9} mb={2} mt={2}>
              {textList.map((text, idx) => {
                return <ElementLi key={idx} text={text} idx={idx + 1} />
              })}
            </Typography>


            <Typography component={"p"} className={"typography-welcome-page"}>
              We are excited to support you and provide you clarity and confidence
              in your retirement!
            </Typography>
            <Typography component={"p"} className={"typography-welcome-page"}>
              After you review your IFW Retirement Roadmap with your IFW Financial
              Professional, he/she will show you options that could improve your
              situation. The suggestions your IFW Financial Professional makes will
              be aligned with The Institute of Financial Wellness' philosophy that
              when it comes to financial decisions; Never Say "Never", Never says "Always" ...It Depends!
            </Typography>
          </Grid>

          <Grid mt={1} mb={1} backgroundColor={"#43ebca"} width={"100%"} pl={5}>
            <Typography component={"p"} color={"#157ee8"} className={"typography-welcome-page"}>
              Remember, there is no one size fits all solution to achieving your
              financial goals, and you deserve a customized strategy that makes sense for you.
            </Typography>
          </Grid>
          <Grid item xs={8} pl={5} >

            <Typography component={"p"} mb={5} className={"typography-welcome-page"}>
              On behalf of the Institute of Financial Wellness, I want to wish you
              the very best on your journey to living your best life in retirement.{" "}
              <b>Let's Get There, Together!</b>
            </Typography>

            <Grid style={{ display: 'flex', flexDirection: 'row', gap: '0 30px' }}>
              <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                <Typography className={"typography-welcome-page"} style={ownerSignElement}>Sincerely, </Typography>
                <Typography className={"typography-welcome-page"} style={ownerSignElement}>Erik Sussman CFP, ChFC, CLU </Typography>
                <Typography className={"typography-welcome-page"} style={ownerSignElement}>CEO & Founder, IFW</Typography>
              </Grid>
              <Grid >
                <img height={'90px'} src={`${ErikSussman}`} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} className={"plan-inputs-footer full-width"}>
        <Grid container spacing={3}>
          <Grid item xs={6} className={"left-button"}>
            <Button onClick={props.prev}><ArrowLeft />Back</Button>
          </Grid>
          <Grid item xs={6} className={"right-button"}>
            <Button onClick={props.next}>Continue<ArrowRight /></Button>
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
};

export default PresentationWelcomePage1;
